import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import ReactDOM from 'react-dom';
import { appendElementById, removeElement } from '@arco-design/mobile-utils';
export function open(Component) {
  return function (config) {
    var baseProps = _extends({
      unmountOnExit: true
    }, config || {}, {
      close: function close() {}
    });

    var dynamicProps = _extends({}, baseProps); // 不同的key用不同的容器挂载
    // @en Different keys are mounted in different containers


    var id = "_ARCO_IMAGE_PREVIEW_DIV_" + (baseProps.key || '') + "_";

    var _appendElementById = appendElementById(id, baseProps.getContainer),
        div = _appendElementById.child;

    var leaving = false;

    function render(props) {
      ReactDOM.render( /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        getContainer: function getContainer() {
          return div;
        }
      })), div);
    }

    function update(newConfig) {
      dynamicProps = _extends({}, dynamicProps, newConfig || {});
      render(dynamicProps);
    }

    function close() {
      leaving = true;
      dynamicProps.openIndex = -1;
      render(dynamicProps);
    }

    dynamicProps.close = close;

    dynamicProps.onClose = function () {
      baseProps.onClose && baseProps.onClose();

      if (baseProps.unmountOnExit) {
        removeElement(div);
      }
    };

    dynamicProps.openIndex = -1;
    render(dynamicProps);
    setTimeout(function () {
      if (leaving) return;
      dynamicProps.openIndex = baseProps.openIndex;
      render(dynamicProps);
    }, 20);
    return {
      close: close,
      update: update
    };
  };
}